import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';
import * as React from 'react';

function UnionIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.70711 0.292893C8.31658 -0.0976312 7.68342 -0.0976312 7.29289 0.292893C6.90237 0.683417 6.90237 1.31658 7.29289 1.70711L12.5858 7L0.9375 7C0.419733 7 0 7.44772 0 8C0 8.55229 0.419733 9 0.9375 9H12.5858L7.29289 14.2929C6.90237 14.6834 6.90237 15.3166 7.29289 15.7071C7.68342 16.0976 8.31658 16.0976 8.70711 15.7071L15.7071 8.70711C16.0976 8.31658 16.0976 7.68342 15.7071 7.29289L8.70711 0.292893Z"
      />
    </SvgIcon>
  );
}

const MemoUnionIcon = React.memo(UnionIcon);
export default MemoUnionIcon;
